module.exports = __webpack_public_path__ + "static/media/photo-cnh-front.ab960373.jpg";